export function Footer() {
  return (
    <footer className="footer">
      <p className="footer-text">
        &copy; {new Date().getFullYear()} Paul Ingalls. All rights reserved.
      </p>
    </footer>
  );
}
